import React, {createContext, useCallback, useEffect, useMemo, useState} from 'react';
import {useTheme} from '@material-ui/core/styles';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import {useLocation} from 'react-router-dom';

export const LayoutUIContex = createContext(null);

export function LayoutUIProvider({ children }) {
    const theme = useTheme();
    const isDesktop = useMediaQuery(theme.breakpoints.up('md'));
    const { pathname } = useLocation();

    const [open, setOpen] = useState(false);        // mobile temporary drawer
    const [pinned, setPinned] = useState(true);     // desktop: mini vs pinned-open
    const [hovering, setHovering] = useState(false);// desktop peek state (internal)

    useEffect(() => {
        if (isDesktop) {
            setOpen(false);
            setPinned(true);
            setHovering(false);
        } else {
            setOpen(false);
            setPinned(false);
            setHovering(false);
        }
    }, [isDesktop]);

    // Close the mobile drawer whenever the route changes — covers NavItem clicks,
    // WorkspaceSelector links, and anything else that navigates while the drawer is open.
    useEffect(() => {
        if (!isDesktop) setOpen(false);
    }, [pathname, isDesktop]);

    const collapsed = useMemo(() => {
        const isExpanded = isDesktop ? (pinned || hovering) : true;
        return isDesktop ? !isExpanded : false;
    }, [isDesktop, pinned, hovering]);

    const togglePinned = useCallback(() => {
        if (isDesktop) setPinned(v => !v);
    }, [isDesktop]);

    const onNavigate = useCallback(() => {
        if (!isDesktop) setOpen(false); // close temporary drawer on mobile
    }, [isDesktop]);

    const value = useMemo(() => ({
        isDesktop,
        open, setOpen,
        pinned, setPinned, togglePinned,
        collapsed,
        // expose only what Sidebar needs to manage hover-peek
        setHovering,
        onNavigate,
    }), [
        isDesktop, open, pinned, collapsed, togglePinned, onNavigate
    ]);

    return <LayoutUIContex.Provider value={value}>{children}</LayoutUIContex.Provider>;
}
